
<template>

	<myframe without_border without_margin title="Формула модели">

		<div class="d-flex mt-2" v-if="base_upks_formula">{{ base_upks_formula }}</div>
		<div class="d-flex mt-2" >{{ upks_formula }}</div>
		<div class="d-flex mt-2" >{{ formula }}</div>

	</myframe>

</template>

<script>

import api from "../../../../../api"
import variables from "../../../../../api/variables"
import myframe from "../../../../widgets/frame"

export default
{
	props :
	{
		version : Object,
	},

	watch :
	{
		version :
		{
			immediate : true,

			handler(version)
			{
				if(version && version.attrs.cost)
				{
					// const base_upks = version.attrs.base_UPKS == null ? "УПКС до применения поправок" : api.round2(version.attrs.base_UPKS)
					const base_upks = api.round2(version.attrs.UPKS)
					// const upks = version.attrs.UPKS == null ? "УПКС" : api.round2(version.attrs.UPKS)
					const area = version.attrs.Area
					// var formula_upks = "УПКС до применения поправок"
					var formula_upks = "УПКС"
					var formula_upks_all_digits = api.format_cost(base_upks)
					var formula_cost = "replace"
					var formula_cost_all_digits = "replace"
					// var is_mul_upks = true
					// var is_mul_cost = true

					// if(version.corrections_applied)
					// 	Object.values(version.corrections_applied).forEach(
					// 		corr =>
					// 		{
					// 			if(corr.type == "Аддитивная поправка к УПКС")
					// 			{
					// 				formula_upks += " + " + corr.key
					// 				formula_upks_all_digits += " + " + corr.value
					// 				is_mul_upks = false
					// 			}
					// 			else if(corr.type == "Мультипликативная поправка к УПКС")
					// 			{
					// 				if(is_mul_upks)
					// 				{
					// 					formula_upks += " * " + corr.key
					// 					formula_upks_all_digits += " * " + corr.value
					// 				}
					// 				else
					// 				{
					// 					formula_upks = "( " + formula_upks + " ) * " + corr.key
					// 					formula_upks_all_digits = "( " + formula_upks_all_digits + " ) * " + corr.value
					// 					is_mul_upks = true
					// 				}
					// 			}
					// 			else if(corr.type == "Аддитивная поправка к кадастровой стоимости")
					// 			{
					// 				formula_cost += " + " + corr.key
					// 				formula_cost_all_digits += " + " + corr.value
					// 				is_mul_cost = false
					// 			}
					// 			else if(corr.type == "Мультипликативная поправка к кадастровой стоимости")
					// 			{
					// 				if(is_mul_cost)
					// 				{
					// 					formula_cost += " * " + corr.key
					// 					formula_cost_all_digits += " * " + corr.value
					// 				}
					// 				else
					// 				{
					// 					formula_cost = "( " + formula_cost + " ) * " + corr.key
					// 					formula_cost_all_digits = "( " + formula_cost_all_digits + " ) * " + corr.value
					// 					is_mul_cost = true
					// 				}
					// 			}
					// 		})

					formula_upks += " * Площадь"
					formula_upks_all_digits += " * " + area
					
					const formula = formula_cost.replace("replace", formula_upks)
					const formula_all_digits = formula_cost_all_digits.replace("replace", formula_upks_all_digits)
					const cost = api.format_cost(version.attrs.cost)

					// this.formula = `КС = ${formula} = ${formula_all_digits} = ${cost} руб.`
					// this.upks_formula = `УПКС = КС / Площадь = ${cost} / ${area} = ${upks} руб.`

					let text = []
					let values = []

					Object.values(variables.CE_approaches.types).forEach((approach) => {
						if (version.group[`cost_evaluation_${approach}`])
						{
							text.push(`УПКС (${variables.CE_approaches.getFullnameByCode(approach).toLowerCase()}) * Вес`)
							values.push(`${api.format_cost(version.attrs[`UPKS_${approach}`])} * ${api.format_cost(version.group[`cost_evaluation_${approach}_coef`] / 100)}`)
						}
					})

					this.upks_formula = `УПКС = ${text.join(" + ")} = ${values.join(" + ")}${(" = " + api.format_cost(api.round2(version.attrs.UPKS))) || ""}`
					this.formula = `Кадастровая стоимость = ${formula} = ${formula_all_digits} = ${cost} руб.`
				}
			}
		},
	},

	components :
	{
		myframe,
	},

	data()
	{
		return {

			base_upks_formula : null,
			formula : null,
			upks_formula : null,

		}
	},

	methods :
	{
	}
}

</script>

